import React, { useState } from 'react';
import CyberBadge from '../common/CyberBadge';
import { Dumbbell, Plus, Eye, Calendar, Clock } from 'lucide-react';

export default function FitnessView({
  rooms = [],
  selectedSlotRoom,
  setSelectedSlotRoom,
  selectedSlots = [],
  setSelectedSlots,
  selectedSlotDate,
  setSelectedSlotDate,
  onFetchRoomSlots,
  onSelectDrawer,
  onOpenCreateModal,
}) {
  const [activeCategory, setActiveCategory] = useState('all');

  const fitnessRooms = rooms.filter(
    (r) =>
      r.moduleType === 'fitness_sports' ||
      r.categoryType === 'gym' ||
      r.categoryType === 'ground_booking' ||
      r.categoryType === 'turf'
  );

  const displayFitness = fitnessRooms;

  return (
    <div className="animate-fade" style={{ display: 'flex', flexDirection: 'column', gap: '28px' }}>
      {/* Header Banner */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
        <div>
          <h1 className="page-title" style={{ fontSize: '1.75rem', fontWeight: 900, color: 'var(--text-primary)', margin: 0, display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Dumbbell size={28} style={{ color: 'var(--neon-cyan)' }} /> Fitness & Ground Turfs Booking ({displayFitness.length})
          </h1>
          <p style={{ fontSize: '0.88rem', color: 'var(--text-secondary)', marginTop: '4px' }}>
            Gym memberships, cricket turf grounds, and hourly sports facility bookings.
          </p>
        </div>

        <button
          className="btn btn-cyan"
          style={{ padding: '10px 20px', borderRadius: '10px', fontSize: '0.88rem' }}
          onClick={() => onOpenCreateModal('fitness_sports', 'ground_booking')}
        >
          <Plus size={16} /> Add Turf / Gym Space
        </button>
      </div>

      {/* SLEEK HIGH-TECH LIST VIEW */}
      {displayFitness.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 20px', background: 'rgba(10,12,20,0.5)', borderRadius: '16px', border: '1px dashed var(--border-color)' }}>
          <Dumbbell size={36} style={{ color: 'var(--text-muted)', marginBottom: '12px' }} />
          <div style={{ color: '#FFFFFF', fontSize: '1.1rem', fontWeight: 800 }}>No Fitness or Sports Spaces Found</div>
          <div style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginTop: '4px' }}>
            There are currently no gym or turf listings in the database. Click "Add Turf / Gym Space" to create one.
          </div>
        </div>
      ) : (
        <div className="cyber-list-container">
          {displayFitness.map((item, idx) => (
            <div
              key={item._id || item.id}
              className="cyber-list-row list-row-animate"
              style={{ animationDelay: `${idx * 0.08}s` }}
            >
              {/* Left Info Column */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div
                  style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '10px',
                    background: 'rgba(0, 240, 255, 0.12)',
                    border: '1px solid rgba(0, 240, 255, 0.35)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 0 12px rgba(0, 240, 255, 0.2)',
                  }}
                >
                  <Dumbbell size={20} style={{ color: 'var(--neon-cyan)' }} />
                </div>
                <div>
                  <div style={{ fontSize: '1.05rem', fontWeight: 800, color: 'var(--text-primary)', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {item.title}
                    <CyberBadge status={item.status || 'approved'} />
                  </div>
                  <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>📍 {item.city || item.location?.city || 'Indore, MP'}</span>
                    <span>•</span>
                    <span className="badge badge-cyan" style={{ fontSize: '0.65rem' }}>
                      {item.categoryType ? item.categoryType.toUpperCase() : 'SPORTS TURF'}
                    </span>
                  </div>
                </div>
              </div>

              {/* Right Action Column */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: '1.15rem', fontWeight: 900, color: 'var(--neon-green)', fontFamily: 'var(--font-mono)' }}>
                    ₹{(Number(item.price) || 0).toLocaleString()} <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>/ {item.priceType || 'hour'}</span>
                  </div>
                  <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: '2px' }}>Slot Booking Enabled</div>
                </div>

                <button
                  className="btn btn-purple"
                  style={{ padding: '8px 14px', fontSize: '0.8rem' }}
                  onClick={() => {
                    setSelectedSlotRoom(item);
                    onFetchRoomSlots(item._id || item.id, selectedSlotDate);
                  }}
                >
                  <Clock size={14} /> Slots Matrix
                </button>

                <button
                  className="btn btn-outline"
                  style={{ padding: '8px 14px', fontSize: '0.8rem' }}
                  onClick={() => onSelectDrawer(item, 'room')}
                >
                  <Eye size={14} /> Details
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
